/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect } from 'react'
import { useSwiperSlide } from 'swiper/react'
import { useIntersectionObserver } from '@/hooks'
import { composeClasses } from '@/utils/compose-classes'

export interface ImageContainerProps {
  photo: string
  index: number
  withOverLay?: boolean
  rounded?: string
  classNameImage?: string
  classNameContainerImage?: string
  setIndexActive: (index: number) => void
}

export const ImageContainer: FC<ImageContainerProps> = ({
  photo,
  index,
  withOverLay,
  setIndexActive,
  rounded,
  classNameImage,
  classNameContainerImage
}) => {
  const {
    isVisible,
    observedElementRef,
    disconnect: disconnectObserver
  } = useIntersectionObserver<HTMLDivElement>({
    threshold: 0
  })

  const swiperSlide = useSwiperSlide()

  useEffect(() => {
    return () => {
      disconnectObserver()
    }
  }, [])

  useEffect(() => {
    if (swiperSlide) {
      if (swiperSlide?.isActive) {
        setIndexActive(index)
      }
    }
  }, [swiperSlide])

  return (
    <div
      ref={observedElementRef}
      data-testid="image-container"
      className={composeClasses(
        rounded,
        classNameContainerImage,
        'object-cover w-full h-full'
      )}
    >
      {(isVisible || index === 0) && (
        <img
          src={photo}
          alt={photo}
          className={composeClasses(
            rounded,
            classNameImage,
            'h-full w-full object-cover'
          )}
        />
      )}
      {withOverLay && (
        <div
          data-testid="overlay"
          className="w-full h-full z-[2] bg-gradient-to-b from-[rgba(0,0,0,0.30)-5.92%] to-[rgba(0,0,0,0.00)-90.19%)] top-0 left-0 absolute"
        />
      )}
    </div>
  )
}
